import React from 'react';
import { Container as MaterialContainer, ContainerProps } from '@material-ui/core';

export const Container: React.ComponentType<ContainerProps> = MaterialContainer;
